var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Other/logo/colored/people") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.5906059%",
    y1: "76.9531302%",
    x2: "79.3721548%",
    y2: "22.1002909%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "49.1568917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/colored/people",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    opacity: 0,
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,80 C163.028,80 172,88.972 172,100 L172,100 L172,118 C172,121.313 169.313,124 166,124 C162.687,124 160,121.313 160,118 L160,118 L160,100 C160,95.589 156.411,92 152,92 C147.589,92 144,95.589 144,100 L144,100 L144,140 C144,151.028 135.028,160 124,160 C112.972,160 104,151.028 104,140 L104,140 L104,100 C104,95.589 100.411,92 96,92 C91.589,92 88,95.589 88,100 L88,100 L88,142 L87.898,142 C86.892,152.093 78.354,160 68,160 C56.972,160 48,151.028 48,140 L48,140 L48,100 C48,95.589 44.411,92 40,92 C35.589,92 32,95.589 32,100 L32,100 L32,118 C32,121.313 29.313,124 26,124 C22.687,124 20,121.313 20,118 L20,118 L20,98 L20.102,98 C21.108,87.907 29.647,80 40,80 C51.028,80 60,88.972 60,100 L60,100 L60,140 C60,144.411 63.589,148 68,148 C72.411,148 76,144.411 76,140 L76,140 L76,100 C76,88.972 84.972,80 96,80 C107.028,80 116,88.972 116,100 L116,100 L116,140 C116,144.411 119.589,148 124,148 C128.411,148 132,144.411 132,140 L132,140 L132,100 C132,88.972 140.972,80 152,80 Z M40,32 C51.028,32 60,40.972 60,52 C60,63.028 51.028,72 40,72 C28.972,72 20,63.028 20,52 C20,40.972 28.972,32 40,32 Z M96,32 C107.028,32 116,40.972 116,52 C116,63.028 107.028,72 96,72 C84.972,72 76,63.028 76,52 C76,40.972 84.972,32 96,32 Z M152,32 C163.028,32 172,40.972 172,52 C172,63.028 163.028,72 152,72 C140.972,72 132,63.028 132,52 C132,40.972 140.972,32 152,32 Z M40,44 C35.589,44 32,47.589 32,52 C32,56.411 35.589,60 40,60 C44.411,60 48,56.411 48,52 C48,47.589 44.411,44 40,44 Z M96,44 C91.589,44 88,47.589 88,52 C88,56.411 91.589,60 96,60 C100.411,60 104,56.411 104,52 C104,47.589 100.411,44 96,44 Z M152,44 C147.589,44 144,47.589 144,52 C144,56.411 147.589,60 152,60 C156.411,60 160,56.411 160,52 C160,47.589 156.411,44 152,44 Z",
    id: "Logo",
    fill: "url(#linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "93142775c56fdfe42fe0dbb22744f18d.svg";
export { ForwardRef as ReactComponent };